'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { ORDER_TYPES } from 'my-purchases/constants/orderTypes'

interface OrderIdentifierProps {
	readonly orderId: string
	readonly className?: string
	readonly type: ORDER_TYPES
}

export function OrderIdentifier({
	orderId,
	className,
	type,
}: OrderIdentifierProps) {
	const { t } = useLabels()
	return (
		<div className={className}>
			<h2>
				{type === ORDER_TYPES.ONLINE
					? t('myPurchases.online.details.order.title')
					: t('myPurchases.online.details.ticket.title')}
			</h2>
			<p data-testid='myPurchases.purchaseDetail.purchase.id'>{orderId}</p>
		</div>
	)
}
